<template>
  <div class="row items-center q-col-gutter-sm" :class="classes">
    <div class="col-auto text-weight-light text-caption text-grey-5">
      {{ getProductName }} {{ $t('Common.Veriosn.Text') }} :: {{ version }}
    </div>
    <div v-if="isDevelopmentMode" class="col-auto">
      <q-icon name="info" color="primary">
        <q-tooltip :offset="[10, 10]">
          <div v-for="(info, index) in gitInfo" :key="`info-${index}`">
            {{ index }} : {{ info }}
            <br />
          </div>
        </q-tooltip>
      </q-icon>
    </div>
  </div>
</template>
<script>
import { productName, version } from '../../../../../../package.json'
import { url } from 'src/config/urls'

export default {
  name: 'AppVersion',
  props: {
    classes: {
      type: String,
    },
    hideProductName: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    version,
    productName,
  }),
  computed: {
    getProductName() {
      return !this.hideProductName ? `${productName} :: ` : ''
    },
    gitInfo() {
      return {
        Hash: process.env.GIT_HASH,
        Branch: process.env.GIT_BRANCH,
        Version: process.env.GIT_VERSION,
        URL: url.apiUrl,
      }
    },
  },
}
</script>
